export default {"src":"/_next/static/image/public/images/ic_pending.280b99a6d0476590c434b1b155ba7e31.svg","height":17,"width":17};